module.exports = __webpack_public_path__ + "static/media/users.fa858c75.svg";